module.exports = __webpack_public_path__ + "media/emails/invitation-instructions-c2532820.png";